import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const TopBrands: React.FC = () => {
  const { t: myTranslate } = useTranslation();
  const navigate = useNavigate();

  const brands = [
    {
      name: "Apple store",
      logo: "/logos/top-brands/Apple_logo_black.svg",
    },
    {
      name: "Samsung",
      logo: "/logos/top-brands/Samsung_Logo.svg",
    },
    {
      name: "Sony",
      logo: "/logos/top-brands/Sony_logo.svg",
    },
    {
      name: "Meta Store",
      logo: "/logos/top-brands/Meta.png",
    },
    {
      name: "Microsoft",
      logo: "/logos/top-brands/Microsoft_logo.svg",
    },
    {
      name: "Nike",
      logo: "/logos/top-brands/Logo_NIKE.svg",
    },
    {
      name: "Adidas",
      logo: "/logos/top-brands/Adidas_Logo.svg",
    },
    {
      name: "Puma",
      logo: "/logos/top-brands/puma-logo.svg",
    },
    {
      name: "Under Armour",
      logo: "/logos/top-brands/Under_armour_logo.svg",
    },
    {
      name: "Centrum",
      logo: "/logos/top-brands/Centrum_(multivitamin)_logo.png",
    },
    {
      name: "Nature Made",
      logo: "/logos/top-brands/Nature_Made_logo.webp",
    },
    {
      name: "Optimum Nutrition",
      logo: "/logos/top-brands/optimum_nutrition.png",
    },
    {
      name: "Garden of Life",
      logo: "/logos/top-brands/garden-of-life-logo-vector.png",
    },
    {
      name: "loreal",
      logo: "/logos/top-brands/L'Oréal_logo.svg",
    },
    {
      name: "CeraVe",
      logo: "/logos/top-brands/Cerave-Logo-Vector.svg-.png",
    },
    {
      name: "E.l.f. Cosmetics",
      logo: "/logos/top-brands/E.l.f. Cosmetics.svg",
    },
    {
      name: "Aquaphor",
      logo: "/logos/top-brands/Aquaphor_logo.svg",
    },
    {
      name: "Charlotte Tilbury beauty",
      logo: "/logos/top-brands/Charlotte-Tilbury.png",
    },
    {
      name: "Estée Lauder beauty, Estée Lauder women",
      logo: "/logos/top-brands/Estee-Lauder.png",
    },
    {
      name: "victoria secret beauty, victoria secret parfume",
      logo: "/logos/top-brands/Victoria-secret.png",
    },
  ];

  const handleBrandClick = (term: string) => {
    const query = encodeURIComponent(term);
    navigate(`/search?query=${query}&retailer=amazon&page=1`);
  };

  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", lg: 1200 },
        mx: "auto",
        mb: 4,
        px: { xs: 1, sm: 0 },
      }}
    >
      <Typography
        variant="h6"
        className="notranslate"
        translate="no"
        sx={{ fontWeight: 700, mb: 2 }}
      >
        {myTranslate("products.topBrands")}
      </Typography>
      <Box
        sx={{
          border: "1px solid #eaebef",
          borderRadius: 2,
          overflow: "hidden",
          boxShadow: "0 10px 30px rgba(15,23,42,0.08)",
          backgroundColor: "#fff",
        }}
      >
        <Grid container spacing={0}>
          {brands.map((brand, idx) => (
            <Grid
              key={brand.name}
              item
              xs={6}
              sm={4}
              md={3}
              sx={{
                borderRight: "1px solid #f2f3f5",
                borderBottom: "1px solid #f2f3f5",
                "&:nth-of-type(4n)": {
                  borderRight: { md: "none" },
                },
                "&:nth-last-of-type(-n+4)": {
                  borderBottom: { md: "none" },
                },
                "&:nth-last-of-type(-n+2)": {
                  borderBottom: { xs: "none", sm: "1px solid #f2f3f5" },
                },
              }}
            >
              <Box
                onClick={() => handleBrandClick(brand.name)}
                sx={{
                  userSelect: "none",
                  cursor: "pointer",
                  p: { xs: 2.25, sm: 3 },
                  minHeight: 110,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "transform 0.16s ease, box-shadow 0.16s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 12px 30px rgba(15,23,42,0.12)",
                  },
                  bgcolor: "transparent",
                }}
              >
                <Box
                  component="img"
                  src={brand.logo}
                  alt={brand.name}
                  sx={{
                    maxWidth: "72%",
                    maxHeight: 52,
                    objectFit: "contain",
                    display: "block",
                    filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.05))",
                  }}
                  onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default TopBrands;
